import { yupResolver } from '@hookform/resolvers/yup';
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import {
  // EstadosImagenChoiceEnum,
  // BucketAwtENUM,
  EstadosOrdenTrabajoEnumChoice,
  ModulosEnumChoice,
  // ModulosEnumChoice,
  ROUTER_PATHS,
  rejectOTByTecnicoSchema,
  // useUploadFile,
  useUploadImagesGeneric,
} from '@/shared';
import {
  useFetchMotivosRechazo,
  // useFetchMotivosRechazo,
  useUpdateOrdenTrabajo,
} from '@/shared/actions/erp';
import { RejectOTByTecnicoData, RejectOTByTecnicoDataAuditoria } from '@/shared/actions/erp/tecnico/instalaciones/asignaciones.actions';
import {
  CustomAutocomplete,
  CustomTextArea,
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import {
  AlertSeverityEnum,
  MotivoRechazo,
  // MotivoRechazoOrdenTrabajo,
  OrdenTrabajo,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useState } from 'react';
import { useAuthStore } from '@/store/auth';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  idOrdenTrabajo: string;
  ordenTrabajo: OrdenTrabajo;
}

type DataToSendAux = {
  estado_imagen_actualizacion?: string;
  motivo_rechazo?: string;
  // motivo_rechazo: data.motivo_rechazo,
  // recoordination_required?: boolean;
  observaciones: any;
  resumen_auditoria?: any;
  estado_orden_trabajo?: string;
  // urls_fotos_rechazo_tecnico: [];
  estado_imagen_entrada?: string;
  estado_imagen_salida?: string;
}

type RechazoFormData = RejectOTByTecnicoData & {
  observacion_actualizacion_tecnico: string;
  rawMotivoRechazo?: MotivoRechazo;
};

export const SendByMotivoRechazoFromOT = {
  toData: "INFORMACIÓN CON INCONSISTENCIAS",
  toPhotos: "FOTOS CON INCONSISTENCIAS"
}

const RejectToUpdateInstalacionAsigTecModal: React.FC<ConfirmRejectOTDialogProps> = ({
  ordenTrabajo,
  open,
  idOrdenTrabajo,
  setOpen,
}) => {
  const navigate = useNavigate();
  const currentUser = useAuthStore(s => s.user);
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.operaciones.auditoriaInstalacionesNav;
  ///* global state
  const setAlert = useUiStore(s => s.setAlert);

  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);

  ///* form -------------------
  const formRechazo = useForm<RechazoFormData>({
    resolver: yupResolver(rejectOTByTecnicoSchema) as any,
    defaultValues: {
      estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO,
    },
  });

  const [showCheckBoxesTipoFotos, setShowCheckBoxesTipoFotos] = useState(false)
  const [problemaFotosEntrada, setProblemaFotosEntrada] = useState(false)
  const [problemaFotosSalida, setProblemaFotosSalida] = useState(false)

  const {
    // image1: fotoRechazoTecnico1,
    setImage1: setFotoRechazoTecnico1,
    // image2: fotoRechazoTecnico2,
    setImage2: setFotoRechazoTecnico2,
  } = useUploadImagesGeneric();

  // const { handleUploadFile } = useUploadFile();

  ///* fetch data
  const { data: motivosRechazoOTData } = useFetchMotivosRechazo({
    modulo: ModulosEnumChoice.ORDEN_TRABAJO
  })


  // const motivosRechazoOT = [
  //   {
  //     codigo: "RECH-TECN-0980",
  //     estado: true,
  //     fecha_creacion: "2024-09-17T16:18:45.219128-05:00",
  //     fecha_modificacion: "2024-09-17T16:18:45.231457-05:00",
  //     id_motivo_rechazo: "3f470c1b-7b2e-47d9-9303-f7009ccc44c6",
  //     nombre: "FOTOS CON INCONSISTENCIAS",
  //     descripcion: "FOTOS CON INCONSISTENCIAS",
  //   },
  //   {
  //     codigo: "RECH-TECN-0981",
  //     estado: true,
  //     fecha_creacion: "2024-09-17T16:18:45.219128-05:00",
  //     fecha_modificacion: "2024-09-17T16:18:45.231457-05:00",
  //     id_motivo_rechazo: "3f470c1b-7b2e-47d9-9303-f7009ccc44c6",
  //     nombre: "INFORMACIÓN CON INCONSISTENCIAS",
  //     descripcion: "INFORMACIÓN CON INCONSISTENCIAS",
  //   }
  // ]

  ///* mutations
  const rejectOrdenTrabajo = useUpdateOrdenTrabajo<RejectOTByTecnicoDataAuditoria>({
    navigate,
    returnUrl: returnUrlInstalacionesTecnicoPage,
    customSuccessMessage: 'Orden de trabajo pre-rechazada correctamente',
  });

  const onSaveRejection = async (data: RechazoFormData) => {

    if(motivosRechazoOTData?.data?.data){

      let dataAux : DataToSendAux = {
        estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR,//!problemaFotosEntrada && !problemaFotosSalida ? EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR:undefined,
        // estado_imagen_actualizacion: problemaFotosEntrada || problemaFotosSalida?EstadosImagenChoiceEnum.UPD_SOLICITADA:undefined,
        motivo_rechazo: data.motivo_rechazo,
        resumen_auditoria: ordenTrabajo?.resumen_auditoria?
        {
          aprobado: false,
          fecha_aprobado: null,
          historial_auditoria:[
            ...ordenTrabajo?.resumen_auditoria?.historial_auditoria,
            {
              revisado_por: currentUser?.username,
              fecha_auditoria: new Date().toISOString(),
              observacion: data.observacion_actualizacion_tecnico,
              motivo_rechazo: data.motivo_rechazo
            }
          ]
        }:
        {
          aprobado: false,
          fecha_aprobado: null,
          historial_auditoria:[
            {
              revisado_por: currentUser?.username,
              fecha_auditoria: new Date().toISOString(),
              observacion: data.observacion_actualizacion_tecnico,
              motivo_rechazo: data.motivo_rechazo
            }
          ]
        }
        ,
        observaciones: {
          ...ordenTrabajo.observaciones,
          observacion_actualizacion_tecnico: data.observacion_actualizacion_tecnico,
          fecha_solicitada_actualizacion_tecnico: new Date().toISOString(),
        },
      }

      // if (showCheckBoxesTipoFotos && !problemaFotosEntrada && !problemaFotosSalida){
      //   return setAlert(true, 'Seleccione la categoría de fotos que tienen inconvenientes', AlertSeverityEnum.error);
      // }
      // if(problemaFotosEntrada && !ordenTrabajo?.urls_fotos_entrada){
      //   return setAlert(true, 'Las fotos de entrada aún no han sido cargadas por el técnico', AlertSeverityEnum.error);
      // }
      // if(problemaFotosSalida && !ordenTrabajo?.urls_fotos_salida){
      //   return setAlert(true, 'Las fotos de salida aún no han sido cargadas por el técnico', AlertSeverityEnum.error);
      // }
      // dataAux.estado_imagen_entrada = problemaFotosEntrada?EstadosImagenChoiceEnum.UPD_SOLICITADA:undefined
      // dataAux.estado_imagen_salida = problemaFotosSalida?EstadosImagenChoiceEnum.UPD_SOLICITADA:undefined


  
      // dataAux.estado_orden_trabajo = EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR
      await rejectOrdenTrabajo.mutateAsync({
        id: idOrdenTrabajo,
        data: dataAux,
      });
      setIsGlobalLoading(false);
      setOpen(false)
    }
    
  };

  return (
    <ScrollableDialogProps
      open={open}
      title="Enviar solicitud de actualización de Orden de Trabajo"
      cancelTextBtn="Cancelar"
      confirmTextBtn="Enviar"
      confirmVariantBtn="outlined"
      // actions
      onClose={() => {
        setOpen(false);
        formRechazo.reset();
        setFotoRechazoTecnico1(null);
        setFotoRechazoTecnico2(null);
      }}
      onConfirm={() => {
        formRechazo.handleSubmit(onSaveRejection, () => {
          setAlert(
            true,
            'Todos los campos son requeridos para rechazar la orden de trabajo',
            AlertSeverityEnum.error
          );
        })();
      }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container spacing={3}>
            {/* -------- text -------- */}
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Por favor, escoja el motivo de actualización y adjunte una observación para la solicitud.
              </Typography>
            </Grid>

            {/* -------- motivo rechazo -------- */}
            <Grid item xs={12}>
              <TabTextLabel
                text="ESTADO INFORME"
                pt="0"
                pb="18px"
                pl="0"
                mt="0"
              />

              <CustomAutocomplete<MotivoRechazo>
                label="Estado Informe"
                name="motivo_rechazo"
                // options
                options={motivosRechazoOTData?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ''}
                optionLabelForEdit={
                  formRechazo.getValues().motivo_rechazo || ''
                }
                isLoadingData={false}
                // validation
                control={formRechazo.control}
                error={formRechazo.formState.errors.motivo_rechazo}
                helperText={
                  formRechazo.formState.errors.motivo_rechazo?.message
                }
                onChangeRawValue={(val)=>{
                  if(val?.nombre==SendByMotivoRechazoFromOT.toPhotos){
                    setShowCheckBoxesTipoFotos(true)
                  }else{
                    setProblemaFotosEntrada(false)
                    setProblemaFotosSalida(false)
                    setShowCheckBoxesTipoFotos(false)
                  }
                  
                  formRechazo.reset({...formRechazo.getValues(), rawMotivoRechazo:val})
                }}
              />
            </Grid>
            {
              showCheckBoxesTipoFotos?
                <Grid item container sx={{margin:"auto"}}>
                  <TabTextLabel
                    text="Escoja las secciones a ser corregidas"
                    pt="12px"
                    pb="18px"
                    pl="0"
                    mt="0"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={problemaFotosEntrada}
                        onChange={()=>setProblemaFotosEntrada(!problemaFotosEntrada)}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    }
                    label={
                      <Typography variant="subtitle2">
                        {"Problema en Fotos Entrada"}
                      </Typography>
                    } 
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={problemaFotosSalida}
                        onChange={()=>setProblemaFotosSalida(!problemaFotosSalida)}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    }
                    label={
                      <Typography variant="subtitle2">
                        {"Problema en Fotos Salida"}
                      </Typography>
                    } 
                  />

                </Grid>
              :null
            }

            {/* -------- descripcion rechazo -------- */}
            <Grid item xs={12}>
              <TabTextLabel
                text="Indique los problemas que se encontraron y deben ser corregidos"
                pt="12px"
                pb="18px"
                pl="0"
                mt="0"
              />

              <CustomTextArea
                label="Observaciones"
                name="observacion_actualizacion_tecnico"
                control={formRechazo.control}
                defaultValue={
                  formRechazo.getValues('observacion_actualizacion_tecnico') || ''
                }
                error={formRechazo.formState.errors.observacion_actualizacion_tecnico}
                helperText={
                  formRechazo.formState.errors.observacion_actualizacion_tecnico
                    ?.message
                }
                required={false}
              />
            </Grid>

          </Grid>
        </>
      }
    />
  );
};

export default RejectToUpdateInstalacionAsigTecModal;
